import { SVGProps } from 'react';
import { cn } from '../../utils';

export const CheckboxBlocked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('mr-auto', props.className)}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.88675 16.3873L5 11.5005L6.864 9.6365L9.88675 12.6592L15.546 7L17.41 8.864L9.88675 16.3873Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.1432 10.4288H8.85753V7.57162C8.85753 6.39019 9.81896 5.42877 11.0004 5.42877C12.1818 5.42877 13.1432 6.39019 13.1432 7.57162V10.4288ZM11.0002 15.4285C10.4088 15.4285 9.92877 14.9485 9.92877 14.357C9.92877 13.7656 10.4088 13.2856 11.0002 13.2856C11.5916 13.2856 12.0716 13.7656 12.0716 14.357C12.0716 14.9485 11.5916 15.4285 11.0002 15.4285ZM14.5714 10.4286V7.57143C14.5714 5.60214 12.9693 4 11 4C9.03071 4 7.42857 5.60214 7.42857 7.57143V10.4286C6.64071 10.4286 6 11.0686 6 11.8571V16.8571C6 17.645 6.64071 18.2857 7.42857 18.2857H14.5714C15.3593 18.2857 16 17.645 16 16.8571V11.8571C16 11.0686 15.3593 10.4286 14.5714 10.4286Z"
      fill="currentColor"
    />
  </svg>
);
